<template>
  <v-card
    class="mx-auto pa-4"
    width="450px"
  >
    <v-card-text>
      <v-form
        ref="formRef"
        @submit.prevent="handleSubmitBtnClick"
      >
        <v-row>
          <v-col cols="12">
            <p class="text-2xl font-weight-semibold text--primary">
              Bem vindo!
            </p>

            <span>Por favor, insira seus dados para realizar o Cadastro</span>
          </v-col>
        </v-row>

        <v-text-field
          v-model="solicitanteData.nome"
          class="my-3"
          dense
          outlined
          maxlength="50"
          label="Nome"
          placeholder="Nome"
          hide-details="auto"
          :rules="[validators.required]"
        />

        <v-text-field
          v-model="solicitanteData.cpf"
          v-mask="'###.###.###-##'"
          class="mb-3"
          dense
          outlined
          label="CPF"
          autocomplete="cpf"
          hide-details="auto"
          :rules="[validators.required, validators.isCpfValido]"
        />

        <v-text-field
          v-model="solicitanteData.email"
          class="mb-3"
          dense
          outlined
          label="E-mail"
          placeholder="email@email.com"
          autocomplete="email"
          hide-details="auto"
          :rules="[validators.required, validators.emailValidator]"
        />

        <v-text-field
          v-model="solicitanteData.celular"
          v-mask="'(##) #####-####'"
          class="mb-3"
          dense
          outlined
          label="Celular"
          hide-details="auto"
          autocomplete="celular"
          :rules="[validators.required, validators.isTelefoneCelularValido]"
        />

        <v-text-field
          v-model="solicitanteData.senha"
          class="mb-3"
          dense
          outlined
          label="Senha"
          placeholder="············"
          hide-details="auto"
          :type="isPasswordVisible ? 'text' : 'password'"
          :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
          :rules="[validators.required, validators.passwordValidator]"
          @click:append="isPasswordVisible = !isPasswordVisible"
        />

        <v-row>
          <v-col cols="12">
            <v-hover v-slot="{ hover }">
              <v-btn
                :color="hover ? '#25D366' : 'primary'"
                block
                type="submit"
              >
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="secondary"
                />
                <span v-else>Cadastrar</span>
              </v-btn>
            </v-hover>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-text class="d-flex align-center justify-center flex-wrap">
      <span class="me-2">Já tem uma conta?</span>

      <router-link
        :to="{ name: 'auth-login' }"
        style="text-decoration: none"
      >
        Faça login agora
      </router-link>
    </v-card-text>

    <v-card v-if="mensagem">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <p class="text--primary text-justify">
              {{ mensagem }}
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            class="mx-auto"
            md="4"
            sm="12"
          >
            <v-btn
              block
              color="primary"
              @click="goToAuthLogin"
            >
              <span>Voltar</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { required, emailValidator, passwordValidator } from '@core/utils/validation'
import router from '@/router'
import ClienteService from '@/services/modules/ClienteService'
import useForm from '@/composables/useForm'
import useCentralStore from '@/store/central'
import { isCpfValido, isTelefoneCelularValido } from '@/utils/validation'

export default {
  setup() {
    const { requestUrl } = storeToRefs(useCentralStore())
    const { formRef, loading } = useForm()

    const solicitanteData = ref({
      urlAlias: requestUrl.value,
      nome: '',
      cpf: '',
      email: '',
      celular: '',
      senha: '',
    })
    const isPasswordVisible = ref(false)
    const mensagem = ref('')

    function goToAuthLogin() {
      router.push({ name: 'auth-login' })
    }

    async function handleSubmitBtnClick() {
      if (loading.value) return

      if (!formRef.value.validate()) {
        Vue.$toast.warning('Preencha os campos corretamente antes de enviar.')
        return
      }

      try {
        loading.value = true
        await ClienteService.createSolicitante(solicitanteData.value)
        goToAuthLogin()
        // mensagem.value = 'Cadastro realizado com sucesso! Foi enviado um e-mail ou SMS para confirmação do seu cadastro.'
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      loading,
      solicitanteData,
      isPasswordVisible,
      mensagem,
      handleSubmitBtnClick,
      goToAuthLogin,
      validators: {
        required,
        isCpfValido,
        emailValidator,
        isTelefoneCelularValido,
        passwordValidator,
      },
      icons: {
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
